<template>
  <div class="breadcrumb-bar">
    <span v-if="icon?.length" class="crumb-icon icon is-small">
      <i class="fa-sm" :class="normalizedIcon" />
    </span>
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li
          v-for="(item, i) in items"
          :key="i"
          :class="{ 'is-active': item.active }"
        >
          <router-link v-if="item.to && !item.active" :to="item.to">
            {{ item.label }}
          </router-link>
          <a v-else href="#">{{ item.label }}</a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import { computed } from 'vue'

function normalizeIcon(icon) {
  if (!icon) return null
  if (Array.isArray(icon)) return icon
  return icon.split(' ')
}

export default {
  name: 'Breadcrumb',
  props: {
    items: {
      type: Array,
      required: true,
      validator: (v) => v.every((item) => item.label),
    },
    icon: {
      type: [String, Array],
      default: null,
    },
  },
  setup(props) {
    const normalizedIcon = computed(() => normalizeIcon(props.icon))
    return { normalizedIcon }
  },
}
</script>

<style lang="scss" scoped>
.breadcrumb-bar {
  display: flex;
  align-items: center;
  min-width: 0;
}

nav.breadcrumb {
  font-family: var(--font-heading);
  align-items: center;
  min-width: 0;
  margin-bottom: 0;

  ul {
    flex-wrap: nowrap;
    justify-content: flex-start;
    min-width: 0;
  }

  li {
    min-width: 0;
  }

  a {
    display: inline-block;
    vertical-align: middle;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

// Mobile-first: hide icon and early crumbs
.crumb-icon {
  display: none;
}
li:not(:last-child) {
  display: none;
}

// Medium: show icon
@container route-breadcrumb (min-width: 200px) {
  .crumb-icon {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    margin-right: 0.75rem;
  }
}

// Large: show all crumbs
@container route-breadcrumb (min-width: 350px) {
  li:not(:last-child) {
    display: list-item;
  }
}
</style>
